<template>
  <a
    v-if="href"
    :href="href"
    :target="target"
    :class="{
      'c-button c-button--link': true,
      ['c-button--' + type]: type,
      ['c-button--default']: defaultStyles,
      [extraClass]: extraClass
    }"
  >
    <slot></slot>
  </a>

  <button
    v-else
    :type="nativeType"
    :class="{
      'c-button c-button--button': true,
      ['c-button--' + type]: type,
      ['c-button--disabled']: disabled,
      ['c-button--default']: defaultStyles,
      [extraClass]: extraClass
    }"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'fh-button',

  props: {
    href: String,
    target: String,
    extraClass: String,
    type: String,
    disabled: Boolean,
    defaultStyles: Boolean,
    nativeType: {
      type: String,
      default: 'button'
    }
  }
}
</script>

<style lang="scss">
.c-button {
  color: inherit;

  &--link {
    text-decoration: none;
  }

  &--button {
    font: inherit;
    overflow: visible;
    user-select: none;
    cursor: pointer;
  }

  &--default {
    border: 1px solid #f7f7f7;
    background-color: #f7f7f7;
    font-size: 1em;
    padding: 0.75em 1em;
    line-height: normal;
  }

  &--disabled {
    cursor: not-allowed;
    background-color: rgba(#f7f7f7, 0.7);
    border-color: rgba(#f7f7f7, 0.7);
    color: rgba(#333, 0.7);
  }
}
</style>
